import { PlusOutlined, DownOutlined } from '@ant-design/icons';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dropdown, Input, Space } from 'antd';
import { Link } from 'react-router-dom';

import {
  ADD_EMPLOYEES_LABEL,
  GET_USERS_IMPORT_TEMPLATE_ENDPOINT,
  SORT_EMPLOYEES_LABEL,
  SORT_EMPLOYEES_PATH,
} from '@app/constants';
import { useUsersAccessRights } from '@app/hooks';
import { openImportTemplateFile } from '@app/utils';

import { useEmployeesPageHeader } from '@pages/Employees/EmployeesList/components/hooks/useEmployeesPageHeader';

import type { MenuProps } from 'antd';

export const EmployeesPageHeader = () => {
  const { isMobile, header, exportToExcel, updateEmployeesByExcel } =
    useEmployeesPageHeader();

  const { hasUserRightToCreate, hasUserRightToExport, hasUserRightToImport } =
    useUsersAccessRights();

  const excelItems: MenuProps['items'] = [
    ...(hasUserRightToExport
      ? [
          {
            key: '1',
            label: (
              <span
                onClick={() => exportToExcel(header.searchId as number)}
                data-testid="export-to-excel"
              >
                Выгрузить в Excel
              </span>
            ),
          },
        ]
      : []),
    ...(hasUserRightToImport
      ? [
          {
            key: '2',
            label: (
              <span
                className="unselectable"
                data-testid="export-employees-template"
                onClick={() =>
                  openImportTemplateFile(GET_USERS_IMPORT_TEMPLATE_ENDPOINT)
                }
              >
                Выгрузить шаблон создания исполнителей
              </span>
            ),
          },
        ]
      : []),
    ...(hasUserRightToImport
      ? [
          {
            key: '3',
            label: (
              <div
                onClick={() =>
                  document.getElementById('UpdateEmployeesByExcel')?.click()
                }
                className="unselectable"
              >
                <span data-testid="create-employees-by-excel">
                  Создание исполнителей через Excel
                </span>
                <Input
                  type="file"
                  style={{ display: 'none' }}
                  id="UpdateEmployeesByExcel"
                  accept=".xlsx, .xls"
                  onChange={(e) => {
                    updateEmployeesByExcel(e);
                  }}
                />
              </div>
            ),
          },
        ]
      : []),
  ];

  const actionItems: MenuProps['items'] = [
    ...(hasUserRightToCreate
      ? [
          {
            key: '1',
            label: <Link to="/employees/add/">{ADD_EMPLOYEES_LABEL}</Link>,
          },
        ]
      : []),
    {
      key: '2',
      label: <Link to={SORT_EMPLOYEES_PATH}>{SORT_EMPLOYEES_LABEL}</Link>,
    },
  ];

  return (
    <Space size="middle">
      {(hasUserRightToExport || hasUserRightToImport) && (
        <Dropdown menu={{ items: excelItems }} data-testid="excel-operations">
          <Button>
            <Space>
              {isMobile ? (
                <FontAwesomeIcon icon={faFileExcel} size={'lg'} />
              ) : (
                <>
                  Операции с Excel
                  <DownOutlined />
                </>
              )}
            </Space>
          </Button>
        </Dropdown>
      )}

      {isMobile ? (
        <Dropdown menu={{ items: actionItems }}>
          <Button type="primary" icon={<PlusOutlined />} />
        </Dropdown>
      ) : (
        <>
          <Button data-testid="sort-employees">
            <Link to={SORT_EMPLOYEES_PATH}>{SORT_EMPLOYEES_LABEL}</Link>
          </Button>
          {hasUserRightToCreate && (
            <Button type="primary" data-testid="add-employee">
              <Link to="/employees/add/">{ADD_EMPLOYEES_LABEL}</Link>
            </Button>
          )}
        </>
      )}
    </Space>
  );
};
